var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "section operations" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers"
          },
          [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "Refresh",
                      disabled: _vm.controlledLocked,
                      type: "primary"
                    },
                    on: { click: _vm.toQuery }
                  },
                  [_vm._v(_vm._s(_vm.$t("FileHistory.Refresh")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_FileHistory_fileUpload"],
                        expression: "['button_FileHistory_fileUpload']"
                      }
                    ],
                    attrs: {
                      no: "fileUpload",
                      disabled: _vm.controlledLocked,
                      type: "primary"
                    },
                    on: {
                      click: function($event) {
                        return _vm.showCloudFile()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("FileHistory.Upload")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: [
                          "button_FileHistory_fileDelete",
                          "role_FileDownloads_ownFileDelete"
                        ],
                        expression:
                          "['button_FileHistory_fileDelete', 'role_FileDownloads_ownFileDelete']"
                      }
                    ],
                    attrs: {
                      no: "fileDelete",
                      disabled:
                        !_vm.showButton ||
                        _vm.deleteBtn ||
                        _vm.controlledLocked,
                      type: "danger"
                    },
                    on: { click: _vm.remove }
                  },
                  [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "download",
                      disabled: _vm.controlledLocked,
                      type: "primary"
                    },
                    on: { click: _vm.download }
                  },
                  [_vm._v(_vm._s(_vm.$t("FileHistory.BatchDownload")))]
                ),
                !_vm.isAssemblyPlan
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          no: "sendEmail",
                          disabled: _vm.controlledLocked,
                          type: "primary"
                        },
                        on: { click: _vm.sendEmail }
                      },
                      [_vm._v(_vm._s(_vm.$t("FileHistory.SendEmail")))]
                    )
                  : _vm._e(),
                _vm.viewSource === "SeBooking" &&
                _vm.job.masterFlag &&
                _vm.oneClickSendDestinationPortAgent
                  ? [
                      _vm.job.sentDestinationPortAgent
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                disabled: "",
                                no: "SentDestinationPortAgent",
                                type: "primary"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("FileHistory.SentDestinationPortAgent")
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      !_vm.job.sentDestinationPortAgent
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "SendDestinationPortAgent",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.sendDestinationPortAgent("16")
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("FileHistory.SendDestinationPortAgent")
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.showSendPackageProxyFilesButton
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "SendPackageProxyFiles",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.sendPackageAgent()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("FileHistory.SendSetOfProxyOrders")
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["role_FileHistory_resetOneClickSend"],
                              expression:
                                "['role_FileHistory_resetOneClickSend']"
                            }
                          ],
                          attrs: { no: "resetOneClickSend", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.resetOneClickSend()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("FileHistory.ResetOneClickSend"))
                          )
                        ]
                      )
                    ]
                  : _vm._e(),
                _vm._l(_vm.remainInstructions, function(item, index) {
                  return [
                    item.platformInstructionRuleCode ===
                    _vm.LCL_RESET_ONE_CLICK_SEND.code
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["role_FileHistory_resetOneClickSend"],
                                expression:
                                  "['role_FileHistory_resetOneClickSend']"
                              }
                            ],
                            key: index,
                            attrs: {
                              no: item.platformInstructionRuleCode,
                              type: "primary",
                              disabled: !item.allowOperate
                            },
                            on: {
                              click: function($event) {
                                return _vm.onInstructionClick(item)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$selectByLang(
                                    item.chineseName,
                                    item.englishName,
                                    item.japaneseName
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      : _c(
                          "el-button",
                          {
                            key: index,
                            attrs: {
                              no: item.platformInstructionRuleCode,
                              type: "primary",
                              disabled: !item.allowOperate
                            },
                            on: {
                              click: function($event) {
                                return _vm.onInstructionClick(item)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$selectByLang(
                                    item.chineseName,
                                    item.englishName,
                                    item.japaneseName
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                  ]
                }),
                _vm.ingotUploadButton
                  ? _c(
                      "el-button",
                      {
                        attrs: { no: "ingotUpload", type: "primary" },
                        on: { click: _vm.ingotUpload }
                      },
                      [_vm._v(_vm._s(_vm.$t("FileHistory.ingotUpload")))]
                    )
                  : _vm._e(),
                _vm.ingotButton
                  ? _c(
                      "el-button",
                      {
                        attrs: { no: "ingotLog", type: "primary" },
                        on: { click: _vm.ingotLog }
                      },
                      [_vm._v(_vm._s(_vm.$t("FileHistory.ingotLog")))]
                    )
                  : _vm._e(),
                _vm.showSyncButton
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          no: "synchronization",
                          disabled:
                            _vm.disabeSyncButton ||
                            _vm.syncBtn ||
                            _vm.controlledLocked,
                          type: "primary"
                        },
                        on: { click: _vm.synchronizationFile }
                      },
                      [_vm._v(_vm._s(_vm.$t("FileHistory.synchronization")))]
                    )
                  : _vm._e(),
                _vm.showSyncButton
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          no: "cancelSynchronization",
                          disabled:
                            _vm.disabeSyncButton ||
                            _vm.cancelBtn ||
                            _vm.controlledLocked,
                          type: "primary"
                        },
                        on: { click: _vm.cancelSynchronization }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("FileHistory.cancelSynchronization"))
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.uploadFileInstruction
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          no:
                            _vm.uploadFileInstruction
                              .platformInstructionRuleCode,
                          type: "primary",
                          disabled: !_vm.uploadFileInstruction.allowOperate
                        },
                        on: {
                          click: function($event) {
                            return _vm.onInstructionClick(
                              _vm.uploadFileInstruction
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$selectByLang(
                                _vm.uploadFileInstruction.chineseName,
                                _vm.uploadFileInstruction.englishName,
                                _vm.uploadFileInstruction.japaneseName
                              )
                            ) +
                            " "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.toExoSystemOC
                  ? _c(
                      "el-button",
                      {
                        attrs: { no: "showPushResultLog", type: "primary" },
                        on: {
                          click: function($event) {
                            _vm.pushResultLogDialog.visible = true
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PushResultLog")))]
                    )
                  : _vm._e(),
                _vm.job.masterFlag
                  ? _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "15px" },
                        on: { change: _vm.showSlaveFileChange },
                        model: {
                          value: _vm.showSlaveFile,
                          callback: function($$v) {
                            _vm.showSlaveFile = $$v
                          },
                          expression: "showSlaveFile"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("FileHistory.DisplayTicketFile")))]
                    )
                  : _vm._e()
              ],
              2
            )
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "section", staticStyle: { flex: "1" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", flex: "1", padding: "10px" },
            attrs: {
              "config-module": "136235",
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.gridParams,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData,
              "check-sub-record": false
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _vm.canOperateJob
        ? _c("drop-uploader", {
            attrs: {
              "auto-upload": _vm.dropAutoUpload,
              action: _vm.URL.common.uploadStorage,
              "upload-params": _vm.uploadParams
            },
            on: {
              "upload-end": _vm.uploadEnd,
              "choose-file": _vm.showCloudFile
            }
          })
        : _vm._e(),
      _vm.fileTypeEditor.visible
        ? _c("mx-file-type-editor", {
            attrs: {
              visible: _vm.fileTypeEditor.visible,
              lob: _vm.job.lob,
              "file-id": _vm.fileTypeEditor.fileId,
              "file-category": _vm.fileTypeEditor.fileCategory,
              "check-type-privilege": true
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.fileTypeEditor, "visible", $event)
              },
              saveFileType: function(data) {
                _vm.itemEditEndHandler(data)
                _vm.updateSopForFileType(data)
              }
            }
          })
        : _vm._e(),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          "upload-source": _vm.uploadSource,
          lob: _vm.cloudFile.job.lob,
          "new-file": _vm.cloudFile.newFile
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: function(data) {
            _vm.updateSop(data)
            _vm.sendFileOC()
          }
        }
      }),
      _vm.isShowingDetailForm
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "DetailTitle",
                "close-on-click-modal": false,
                visible: _vm.isShowingDetailForm,
                title: _vm.showDetailTitle,
                width: "450px",
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.isShowingDetailForm = $event
                }
              }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "400px", height: "300px" },
                attrs: {
                  "grid-options": _vm.gridOptionsFileDetail,
                  "column-defs": _vm.columnDefsFileDetail,
                  "row-data": _vm.rowDataFileDetail
                },
                on: {
                  gridReady: function(params) {
                    return (_vm.gridApiFileDetail = params.api)
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.sendEmailDialog.visible
        ? _c("send-email-dialog", {
            ref: "sendEmailDialog",
            attrs: {
              visible: _vm.sendEmailDialog.visible,
              context: _vm.context,
              job: _vm.job,
              "job-uuid-list": _vm.sendEmailDialog.jobUuidList,
              source: _vm.source,
              "push-link": _vm.SystemConstants.FILE_HISTORY,
              "send-email-data": _vm.sendEmailDialog,
              "view-source": _vm.viewSource,
              "append-to-body": ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.sendEmailDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "ingotLog",
            "close-on-click-modal": false,
            visible: _vm.ingot.visible,
            title: _vm.$t("FileHistory.ingotLog"),
            width: "600px;",
            height: "400px;",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.ingot, "visible", $event)
            },
            close: _vm.ingotClose
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "350px" },
            attrs: {
              "grid-options": _vm.ingot.gridOptions,
              "grid-params": _vm.ingot.gridParams,
              "column-defs": _vm.ingot.columnDefs,
              "row-data": _vm.ingot.rowData
            },
            on: {
              "update:gridParams": function($event) {
                return _vm.$set(_vm.ingot, "gridParams", $event)
              },
              "update:grid-params": function($event) {
                return _vm.$set(_vm.ingot, "gridParams", $event)
              },
              gridReady: function(params) {
                return (_vm.ingot.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c("pre-view-file-dialog", {
        attrs: {
          "v-if": _vm.previewFileData.visible,
          no: "preview",
          title: _vm.$t("FileHistory.preview"),
          visible: _vm.previewFileData.visible,
          file: _vm.previewFileData.file,
          "can-maximize": true
        },
        on: { close: _vm.closePreviewDialog }
      }),
      _vm.pushResultLogDialog.visible
        ? _c("push-result-log-dialog", {
            attrs: {
              visible: _vm.pushResultLogDialog.visible,
              "job-uuid": _vm.job.uuid || "",
              "job-keys": _vm.pushResultLogDialog.jobKeys,
              "log-source": "file"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.pushResultLogDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingWindow.visible
        ? _c("checking-send-destination-agent-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              "is-pass": _vm.checkingWindow.isPass,
              "master-info": _vm.checkingWindow.masterInfo,
              "slave-info": _vm.checkingWindow.slaveInfo,
              "row-data": _vm.checkingWindow.rowData,
              "show-next": _vm.checkingWindow.showNext,
              "match-instruction-tip": _vm.checkingWindow.matchInstructionTip
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              },
              next: _vm.sendDestinationPortAgentNext
            }
          })
        : _vm._e(),
      _vm.sendDestinationPortAgentEmailDialog.visible
        ? _c("send-destination-port-agent-email-dialog", {
            attrs: {
              visible: _vm.sendDestinationPortAgentEmailDialog.visible,
              job: _vm.job,
              "file-list": _vm.sendDestinationPortAgentEmailDialog.fileList,
              "push-link": _vm.sendDestinationPortAgentEmailDialog.pushLink,
              "mail-template-uuid":
                _vm.sendDestinationPortAgentEmailDialog.mailTemplateUuid,
              "exchange-agent-data":
                _vm.sendDestinationPortAgentEmailDialog.exchangeAgentData,
              "file-type-of-take-multi":
                _vm.sendDestinationPortAgentEmailDialog.fileTypeOfTakeMulti,
              "mail-template-interface-type":
                _vm.sendDestinationPortAgentEmailDialog
                  .mailTemplateInterfaceType
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.sendDestinationPortAgentEmailDialog,
                  "visible",
                  $event
                )
              },
              callback: _vm.sendDestinationPortAgentCallback,
              instructionCallback: function(data) {
                return _vm.instructionCallback(
                  Object.assign(
                    { instructionUuid: _vm.checkingWindow.instructionUuid },
                    data
                  )
                )
              }
            }
          })
        : _vm._e(),
      _c("exchange-agent-select-dialog", {
        attrs: {
          visible: _vm.exchangeAgentSelectDialog.visible,
          "job-uuid": _vm.exchangeAgentSelectDialog.jobUuid,
          "exchange-agents": _vm.exchangeAgentSelectDialog.exchangeAgents
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.exchangeAgentSelectDialog, "visible", $event)
          },
          callback: _vm.onSelectExchangeAgent
        }
      }),
      _c("one-click-send-window", {
        ref: "oneClickSendWindow",
        attrs: { "file-type-caps-map": _vm.fileTypeCapsMap },
        on: {
          writebackJob: _vm.onWritebackJob,
          instructionCallback: _vm.onInstructionCallback
        }
      }),
      _c("upload-file-window", {
        ref: "uploadFileWindow",
        on: { instructionCallback: _vm.onInstructionCallback }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }